import type { Invoice } from '../types';

/**
 * Vérifie qu'une facture a les informations minimales pour être approuvée.
 * Conditions : client réel, au moins une ligne valide, date d'émission.
 */
const NO_CLIENT_COMPANY_NAMES = new Set(['Brouillon (sans client)', 'Draft (no client)']);

export function hasRealClientCompanyName(companyName: string | undefined): boolean {
  const v = companyName?.trim();
  if (!v) return false;
  // Le back (mock) exige un companyName non vide pour créer un brouillon.
  // Quand aucun client n'est sélectionné, le front enregistre un placeholder.
  return !NO_CLIENT_COMPANY_NAMES.has(v);
}

export function canApproveInvoice(invoice: Invoice): boolean {
  if (!hasRealClientCompanyName(invoice.companyName)) return false;
  const hasValidLine = invoice.lines.some(
    l => l.label?.trim() && l.quantity > 0 && l.unitPrice > 0,
  );
  if (!hasValidLine) return false;
  if (!invoice.issuedAt?.trim()) return false;
  return true;
}
